(() => {
  'use strict';
  const ID = 'gg_trio_paid_2026_10';
  const CAMPAIGN = 'gg_trio_ab_2026_10';
  const KEYS = ['gg_paid_trio_id', 'gg_paid_trio_arm', 'gg_paid_trio_qa'];
  function windowOpen(config, now = Date.now()) {
    const start = Date.parse(config.start), end = Date.parse(config.end);
    return config.enabled === true && config.country === 'US' && Number.isFinite(start) && Number.isFinite(end) && start <= now && now < end;
  }
  function eligible(url, config, now = Date.now()) {
    const q = url.searchParams;
    return windowOpen(config, now) && url.pathname.endsWith('/products/oral-care-trio') && url.pathname === config.productPath && q.get('view') === 'gg-trio-entry' && q.get('utm_source') === 'google' && q.get('utm_medium') === 'cpc' && q.get('utm_campaign') === CAMPAIGN;
  }
  function chooseArm(sample) {
    if (!Number.isInteger(sample) || sample < 0 || sample > 4294967295) throw new TypeError('Invalid random sample');
    return sample < 2147483648 ? 'A' : 'B';
  }
  function destination(url, arm) {
    const next = new URL(url.href);
    next.searchParams.delete('gg_qa_arm');
    if (arm === 'A' || arm === 'B') next.searchParams.set('view', arm === 'A' ? 'gg-trio-a' : 'gg-trio-b');
    else next.searchParams.delete('view');
    return next;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { ID, eligible, chooseArm, destination, windowOpen };
  if (typeof document === 'undefined') return;
  const configNode = document.getElementById('gg-paid-trio-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const current = new URL(location.href);
  const onProduct = current.pathname === config.productPath && current.pathname.endsWith('/products/oral-care-trio');
  const entry = config.suffix === 'gg-trio-entry';
  const preview = config.qa === true;
  const previewArm = preview ? current.searchParams.get('gg_qa_arm') : null;
  let busy = false;
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const active = () => windowOpen(config) && ['A', 'B'].includes(config.arm) && (preview || config.qaAssigned !== '1');
  const navigate = arm => {
    const url = destination(current, arm);
    if (url.href !== location.href) location.replace(url.href);
  };
  const savedArm = () => {
    if (!permitted() || !windowOpen(config)) return null;
    try {
      const saved = JSON.parse(localStorage.getItem(ID) || 'null');
      return saved?.end === config.end && ['A', 'B'].includes(saved.arm) ? saved.arm : null;
    } catch { return null; }
  };
  const remember = arm => {
    if (!permitted()) return;
    try { localStorage.setItem(ID, JSON.stringify({ arm, end: config.end })); } catch { return; }
  };
  const update = async attributes => {
    const response = await fetch((window.Shopify?.routes?.root || config.cartRoot || '/') + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }),
      signal: AbortSignal.timeout(8000)
    });
    if (!response.ok) throw new Error('Assignment update failed');
    return response.json();
  };
  const clear = async () => {
    await update(Object.fromEntries(KEYS.map(key => [key, ''])));
    config.arm = '';
    try { localStorage.removeItem(ID); } catch { return; }
  };
  const assign = async (arm, qa = false) => {
    if (busy || !permitted() || !windowOpen(config)) return false;
    busy = true;
    try {
      const response = await update({ gg_paid_trio_id: ID, gg_paid_trio_arm: arm, gg_paid_trio_qa: qa ? '1' : '' });
      if (response.attributes?.gg_paid_trio_id !== ID || response.attributes?.gg_paid_trio_arm !== arm) throw new Error('Assignment readback failed');
      if (!permitted()) { await clear(); return false; }
      config.arm = arm;
      if (!qa) remember(arm);
      navigate(arm);
      return true;
    } catch {
      const status = document.querySelector('[data-gg-entry-status]');
      if (status) status.textContent = document.querySelector('[data-gg-entry-fallback]')?.textContent || '';
      try { await clear(); } catch { return false; }
      if (!qa) navigate(null);
      return false;
    } finally { busy = false; }
  };
  document.querySelectorAll('[data-gg-preview-arm]').forEach(button => button.addEventListener('click', () => assign(button.dataset.ggPreviewArm, true)));
  document.querySelector('[data-gg-preview-reset]')?.addEventListener('click', async () => {
    if (!preview || busy) return;
    busy = true;
    try { await clear(); navigate(null); } finally { busy = false; }
  });
  let privacyResolved = false;
  const initialize = async () => {
    if (!window.Shopify?.customerPrivacy) return;
    privacyResolved = true;
    if (preview && entry && current.searchParams.get('gg_qa_hold') === '1') return;
    if (!windowOpen(config)) { if (onProduct && (entry || config.suffix === 'gg-trio-b')) navigate(null); return; }
    if (!permitted()) {
      try { localStorage.removeItem(ID); } catch {}
      if (config.arm) { try { await clear(); } catch { return; } }
      if (onProduct && !preview) navigate(null);
      return;
    }
    if (preview && entry && ['A', 'B'].includes(previewArm)) { await assign(previewArm, true); return; }
    if (active()) {
      if (config.qaAssigned !== '1') remember(config.arm);
      if (onProduct && (entry || config.suffix !== (config.arm === 'A' ? 'gg-trio-a' : 'gg-trio-b'))) navigate(config.arm);
      return;
    }
    const remembered = savedArm();
    if (remembered && onProduct && config.qaAssigned !== '1') { await assign(remembered); return; }
    if (eligible(current, config)) {
      if (!window.crypto?.getRandomValues) { navigate(null); return; }
      if (!navigator.locks?.request) { navigate(null); return; }
      await navigator.locks.request('gg-paid-trio-enrollment', async () => {
        const cartResponse = await fetch((window.Shopify?.routes?.root || config.cartRoot || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
        if (!cartResponse.ok) throw new Error('Assignment lookup failed');
        const cart = await cartResponse.json();
        if (cart.attributes?.gg_paid_trio_id === ID && ['A', 'B'].includes(cart.attributes.gg_paid_trio_arm) && cart.attributes.gg_paid_trio_qa !== '1') {
          config.arm = cart.attributes.gg_paid_trio_arm;
          remember(config.arm);
          if (permitted()) navigate(config.arm);
          return;
        }
        const remembered = savedArm();
        const sample = crypto.getRandomValues(new Uint32Array(1))[0];
        await assign(remembered || chooseArm(sample));
      }).catch(() => navigate(null));
    } else if (onProduct && (entry || config.suffix === 'gg-trio-b') && !preview) navigate(null);
  };
  document.addEventListener('visitorConsentCollected', async () => {
    if (!permitted()) { try { localStorage.removeItem(ID); } catch {} }
    if (!permitted() && config.arm) {
      try { await clear(); location.reload(); } catch { return; }
    }
  });
  if (window.Shopify?.customerPrivacy) initialize();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) initialize(); });
  setTimeout(() => { if (!privacyResolved && entry && !preview) navigate(null); }, 4000);
})();
